import { render } from "./office-info.vue?vue&type=template&id=f3880062&scoped=true&ts=true"
import script from "./office-info.vue?vue&type=script&lang=ts"
export * from "./office-info.vue?vue&type=script&lang=ts"

import "./office-info.vue?vue&type=style&index=0&id=f3880062&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3880062"]])

export default __exports__